import { PointsService } from '../points.service'
import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'customization',
  templateUrl: './customization.component.html',
  styleUrls: ['./customization.component.scss']
})
export class CustomizationComponent implements OnInit {
  points!: FormGroup
  saving = false

  constructor(private fb: FormBuilder, private builderService: BuilderService, private pointsService: PointsService) {}

  ngOnInit(): void {
    this.createForm()
    this.updateFormFields()
  }

  updateFormFields() {
    this.pointsService.getPointsCustomization()
      .then((data) => {
        if (data) {
          this.points.patchValue({
            customization: data.customization ?? '',
            popupMessage: data.popup_message ?? '',
            pointsPushNotification: data.points_push_notification ?? false,
            notificationDate: data.notification_date ?? '',
            expirationDate: data.expiration_date ?? '',
            termsConditions: data.terms_conditions ?? ''
          })
        }
      })
      .catch((error) => console.error('Error loading points customization data:', error))
  }

  createForm() {
    this.points = this.fb.group({
      customization: ['', Validators.required],
      popupMessage: [''],
      pointsPushNotification: [false],
      notificationDate: [''],
      expirationDate: [''],
      termsConditions: ['']
    })
  }

  saveChanges() {
    const formValue = this.points.value
    this.saving = true
    this.pointsService.upsertPointsCustomization({
      customization: formValue.customization ?? null,
      popup_message: formValue.popupMessage ?? null,
      points_push_notification: formValue.pointsPushNotification ?? false,
      notification_date: formValue.notificationDate ?? null,
      expiration_date: formValue.expirationDate ?? null,
      terms_conditions: formValue.termsConditions ?? null,
    }).then(() => {
      console.log('Points customization saved successfully!')
    }).catch((error) => {
      console.error('Error saving points customization:', error)
    }).finally(() => {
      this.saving = false
    })
  }
}
